import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AlertsService, Language, LanguageService, MenuItemService, Reflection } from 'itcores-fw';
import { ArcoMenu } from 'src/app/modules/auth/models/arco-menu';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { SecurityService } from 'src/app/modules/auth/services/security.service';

declare let $: any;

@Component({
  selector: 'app-left-side-menu',
  templateUrl: './left-side-menu.component.html',
  styleUrls: ['./left-side-menu.component.css']
})
export class LeftSideMenuComponent implements OnInit {
  lang: Language;
  filteredMenuItems: ArcoMenu[];
  searchKey: string;
  menuItemsArr: ArcoMenu[];
  leftMenuToggle: any;
  loginUrl: string;

  constructor(
    private translate: TranslateService,
    private _language: LanguageService,
    private _menuItemService: MenuItemService,
    private securityService: SecurityService,
    private titleService: Title,
    private alertsService: AlertsService,
    private authService: AuthService
  ) {
    // this._menuItemService.change.subscribe(() => { });
    this.loginUrl = environment.arcoLoginUrl + 'Account/InternalERPLogin?Module=ERP&id_token=' + authService.getToken();
  }

  ngOnInit() {
    this.loadMenuItems();
    this.filteredMenuItems = [];
    this.initMenuItems();

    this._language.LangChanged.subscribe((value: Language) => {
      this.translate.use(value);

      this.lang = value;
    });
  }
  searchover() {
    $('#sidebar').removeClass('collapse');
    $('.content').removeClass('expand');
  }
  clickpin() {
    $('#sidebar').toggleClass('collapse');
    $('.content').toggleClass('expand');
    $('.menu-toggle i').toggleClass(' la-angle-double-right');
    $('.body-overlay').toggle(500);
    $('.sidebar .menu-submenu').removeClass('show');
  }

  isActiveParent(menuItemLI: HTMLElement) {

    if (!($('.sidebar').hasClass('collapse') && $(window).width() >= 1025)) {
      return $(menuItemLI).find('.active-link').length > 0;
    } else {
      return false;
    }
  }
  ActiveParent(menuItemLI: HTMLElement) {
    return $(menuItemLI).find('.active-link').length > 0;

  }
  onSetTitle(title: string) {
    this.titleService.setTitle('ARCO Business Sector - ' + title);
  }

  initMenuItems() {
    const menuItems = this.securityService.getMenuItems() || [];
    this.menuItemsArr = menuItems.sort((a, b) => a.MenuOrder - b.MenuOrder);
    this.filteredMenuItems = [
      ...Reflection.treeify<ArcoMenu>(
        this.menuItemsArr,
        'MenuId',
        'ParentKey',
        'subMenus'
      ).subMenus,
    ];
  }

  loadMenuItems() {
    this.securityService.getUserMenu().subscribe((result) => {
      this.securityService.setMenuItems(result.data);
      this.initMenuItems();
    });
    // prevent open menu on routing 
    console.log('reload menu');
    if (($('.sidebar').hasClass('collapse'))) {
      $('#sidebar').addClass('collapse');
      $('.content').addClass('expand');

    }

  }

  filterMenus() {
    if (!this.searchKey || this.searchKey.trim() === '') {
      this.filteredMenuItems = Reflection.treeify<ArcoMenu>(
        this.menuItemsArr,
        'MenuId',
        'ParentKey',
        'subMenus'
      ).subMenus;
      return;
    }
    this.filteredMenuItems = [];
    for (let index = 0; index < this.menuItemsArr.length; index++) {
      const menuItem = this.menuItemsArr[index];
      if (
        (this.menuItemsArr[index].title &&
          this.menuItemsArr[index].title
            .toLowerCase()
            .includes(this.searchKey.trim().toLowerCase())) ||
        (this.menuItemsArr[index].titleAr &&
          this.menuItemsArr[index].titleAr
            .toLowerCase()
            .includes(this.searchKey.trim().toLowerCase()))
      ) {
        if (this.filteredMenuItems.indexOf(menuItem) === -1) {
          this.filteredMenuItems.push(menuItem);
        }
        this.findParent(menuItem);
        this.findChildren(menuItem);
      }
    }
    this.filteredMenuItems.sort((a, b) => a.MenuOrder - b.MenuOrder);
    this.filteredMenuItems = Reflection.treeify<ArcoMenu>(
      this.filteredMenuItems,
      'MenuId',
      'ParentKey',
      'subMenus'
    ).subMenus;
  }

  findChildren(item: ArcoMenu) {
    if (
      !item.ParentKey ||
      this.menuItemsArr.find((i) => i.ParentKey === item.MenuId.toString())
    ) {
      const children = this.menuItemsArr.filter(
        (i) => i.ParentKey === item.MenuId.toString()
      );
      if (children && children.length > 0) {
        for (let index = 0; index < children.length; index++) {
          const child = children[index];
          if (child && this.filteredMenuItems.indexOf(child) === -1) {
            this.filteredMenuItems.push(child);
          }
          this.findChildren(child);
        }
      }
    }
  }

  findParent(item: ArcoMenu) {
    if (
      item.ParentKey &&
      !this.filteredMenuItems.find(
        (p) => p.MenuId.toString() === item.ParentKey
      )
    ) {
      const parent = this.menuItemsArr.find(
        (m) => m.MenuId.toString() === item.ParentKey
      );
      if (parent) {
        if (this.filteredMenuItems.indexOf(parent) === -1) {
          this.filteredMenuItems.push(parent);
        }
        if (parent.ParentKey) {
          this.findParent(parent);
        }
      }
    }
  }

  onReset() {
    this.searchKey = '';
    this.filterMenus();
  }

  onRefresh() {
    this.alertsService.showLoader();
    this.securityService.getUserMenu().subscribe(
      (result) => {
        this.securityService.setMenuItems(result.data);
        this.initMenuItems();
        this.alertsService.hideLoader();
      },
      this.alertsService.hideLoader(),
      this.alertsService.hideLoader()
    );

  }

}
